import UsersActions from "./users";
import RolesActions from "./roles";

const logicArr = [
  ...UsersActions,
  ...RolesActions
];

export default logicArr;


